"use strict";

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Node_1 = __importDefault(require("./Node"));

var TableRow = /*#__PURE__*/function (_Node_1$default) {
  _inherits(TableRow, _Node_1$default);

  var _super = _createSuper(TableRow);

  function TableRow() {
    _classCallCheck(this, TableRow);

    return _super.apply(this, arguments);
  }

  _createClass(TableRow, [{
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        block: "tr"
      };
    }
  }, {
    key: "name",
    get: function get() {
      return "tr";
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        content: "(th | td)*",
        tableRole: "row",
        parseDOM: [{
          tag: "tr"
        }],
        toDOM: function toDOM() {
          return ["tr", 0];
        }
      };
    }
  }]);

  return TableRow;
}(Node_1.default);

exports.default = TableRow;